/**
 * Generates a JSON signature containing browser and system information.
 * This function is modernized for compatibility with modern browsers and React.
 */
export function jsonSignature() {
    const signature = {};

    // Collect navigator properties
    const navigatorMap = {};
    for (const prop in navigator) {
        try {
            const value = navigator[prop];
            if (
                typeof value === "boolean" ||
                typeof value === "number" ||
                typeof value === "string" ||
                Array.isArray(value) ||
                value === null
            ) {
                navigatorMap[prop] = value;
            }
        } catch (e) {
            console.error(`Error accessing navigator property ${prop}:`, e);
        }
    }
    signature["navigator"] = navigatorMap;

    // Collect screen properties
    const screenProps = ["availHeight", "availWidth", "colorDepth", "height", "pixelDepth", "width"];
    const screenMap = {};
    screenProps.forEach((prop) => {
        try {
            const value = window.screen[prop];
            if (value != null) {
                screenMap[prop] = value;
            }
        } catch (e) {
            console.error(`Error accessing screen property ${prop}:`, e);
        }
    });
    signature["screen"] = screenMap;

    // Collect plugin information
    const plugins = [];
    if (navigator.plugins) {
        for (let i = 0; i < navigator.plugins.length; i++) {
            const plugin = navigator.plugins[i];
            plugins.push({
                name: plugin.name,
                description: plugin.description,
                version: plugin.version || "N/A",
            });
        }
    }
    signature["plugins"] = plugins;

    // Collect timezone information
    const extraMap = {};
    try {
        const currDate = new Date();
        const timezoneOffset = currDate.getTimezoneOffset();
        extraMap["timezone"] = timezoneOffset;
    } catch (e) {
        console.error("Error accessing timezone information:", e);
        extraMap["timezone"] = "N/A";
    }

    // Add JavaScript version (static value for modern browsers)
    extraMap["javascript_ver"] = "ES6+";
    signature["extra"] = extraMap;

    // Return the JSON string representation of the signature
    return JSON.stringify(signature);
}

/**
 * Plugin utility functions for detecting browser plugins.
 */
// export const PluginUtils = {
//     isInstalled: (pluginName) => {
//         if (!navigator.plugins) return false;
//         return Array.from(navigator.plugins).some((plugin) => plugin.name.includes(pluginName));
//     },
//     getVersion: (pluginName) => {
//         if (!navigator.plugins) return "N/A";
//         const plugin = Array.from(navigator.plugins).find((plugin) => plugin.name.includes(pluginName));
//         return plugin ? plugin.version || "N/A" : "N/A";
//     },
//     getInfo: (pluginName) => {
//         if (!navigator.plugins) return null;
//         const plugin = Array.from(navigator.plugins).find((plugin) => plugin.name.includes(pluginName));
//         if (!plugin) return null;
//         return {
//             name: plugin.name,
//             description: plugin.description,
//             version: plugin.version || "N/A",
//         };
//     },
// };